import React, { useState } from "react";
import { Dimensions, Image as Img, Platform, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { ModalAlignmentEnum } from "@voltmoney/types";
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, FontSizeTokens, FontTransformToken, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { Space } from "../../space/Space";
import { Icon } from "../../icon/Icon";
import ThemeProvider from "@voltmoney/theme";
import { Typography } from "../../typography/Typography";
import { addSuffix, isMobile, isMobileView, isMobileViewApp } from "../../stack/utils";
import { Button } from "../../button/Button";
import BottomSheet from "../BottomSheet";
import { addCommasToNumber, getScreenType } from "../utils";
import { Image } from "../../image/Image";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import CustomHeader from "../../customHeader/CustomHeader";
import { LENDER_ID } from "../constants";
const LoanRenewalLandingPage = ({ loanExpiryDays, actualLoanAmount, ctaAction, height, faqAction, chargesData, isRenewalAfterExpiry, needHelpAction, goBackAction, triggerAction, lenderId, }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [howItWorks, setHowItWorks] = useState(false);
    const [renewalFee, setRenewalFee] = useState(false);
    const [isBtnLoading, setBtnIsLoading] = useState(false);
    const [_chargesData, setChargesData] = useState(chargesData);
    const isFromMobileViewApp = isMobileViewApp();
    const _isFontMobile = () => {
        if (Platform.OS !== "web") {
            return true;
        }
        else if (isFromMobileViewApp) {
            return true;
        }
        else {
            return false;
        }
    };
    const isFontMobile = _isFontMobile();
    const onPressHowRenewalWorks = () => {
        setHowItWorks(true);
    };
    const onPressFeeDetails = () => {
        setRenewalFee(true);
    };
    const onPressFaq = async () => {
        faqAction &&
            await triggerAction(faqAction);
    };
    const calExpiryLabel = () => {
        let label = '';
        if (isRenewalAfterExpiry) {
            label = 'LOAN ACCOUNT EXPIRED!';
        }
        else if (loanExpiryDays === 0) {
            label = 'Last day remaining to renew your loan';
        }
        else if (loanExpiryDays === 1) {
            label = `${loanExpiryDays} day remaining to renew your loan`;
        }
        else
            label = `${loanExpiryDays} days remaining to renew your loan`;
        return label;
    };
    const WarningRender = () => {
        return (React.createElement(View, { style: {
                backgroundColor: '#FEECEB',
                paddingHorizontal: 16,
                paddingVertical: 4,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                width: '100%'
            } },
            React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.MD }),
            React.createElement(Space, { size: SizeTypeTokens.Size6 }),
            React.createElement(Typography, { label: calExpiryLabel(), textTransform: FontTransformToken.uppercase, typeDLS: TypographyTypeDLS.B3S, color: ColorTokens.System_Error })));
    };
    const CreditLimitCard = () => {
        return (React.createElement(View, { style: [
                styles.creditLimitCardContainer,
                {
                    borderColor: colorMapping[ColorTokens.Grey_Chalk],
                    backgroundColor: colorMapping[ColorTokens.White]
                }
            ] },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: colorMapping[ColorTokens.Grey_Chalk],
                        padding: 5,
                        borderRadius: 10
                    } },
                    React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pledge_assets.png" }, style: { width: 42, height: 42 } })),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'column'
                    } },
                    React.createElement(Typography, { label: 'Credit limit', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Space, { size: SizeTypeTokens.SM }),
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        } },
                        React.createElement(Typography, { label: `₹`, fontWeight: '700', color: ColorTokens.Grey_Night, fontSize: isFontMobile ? FontSizeTokens.XXXXL : FontSizeTokens.XXL, lineHeight: isFontMobile ? 40 : 32 }),
                        React.createElement(Typography, { label: `${actualLoanAmount}`, typeDLS: TypographyTypeDLS.H1B, color: ColorTokens.Grey_Night }))))));
    };
    const BenefitCardDivider = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Space, { size: SizeTypeTokens.XL })));
    };
    const RenewalCardDivider = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(View, { style: {
                    width: '100%',
                    height: 1,
                    backgroundColor: colorMapping[ColorTokens.Grey_Chalk]
                } }),
            React.createElement(Space, { size: SizeTypeTokens.LG })));
    };
    const BenefitCard = () => {
        return (React.createElement(View, { style: [
                {
                    borderColor: colorMapping[ColorTokens.Grey_Chalk]
                },
                styles.card1
            ] },
            React.createElement(View, { style: styles.card1ItemContainer },
                React.createElement(Image, { size: ImageSizeTokens.SM, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/loanRenewalGreenThunder.svg' }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Text, null,
                        React.createElement(Typography, { label: 'Continued access to instant funds', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night })))),
            BenefitCardDivider(),
            React.createElement(View, { style: styles.card1ItemContainer },
                React.createElement(Image, { size: ImageSizeTokens.SM, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/loanRenewalGreenRupee.svg' }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Text, null,
                        React.createElement(Typography, { label: 'Avoid repayment of outstanding amount', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night })))),
            BenefitCardDivider(),
            React.createElement(View, { style: styles.card1ItemContainer },
                React.createElement(Image, { size: ImageSizeTokens.SM, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/loanRenewalGreenTrending.svg' }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Text, null,
                        React.createElement(Typography, { label: 'Let your portfolio grow & meet long term goals', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }))))));
    };
    const TopCardRender = () => {
        return (React.createElement(View, { style: {
                backgroundColor: colorMapping[ColorTokens.White],
                padding: 16,
                width: '100%',
                borderBottomWidth: 1,
                borderBottomColor: colorMapping[ColorTokens.Grey_Chalk]
            } },
            CreditLimitCard(),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(Button, { label: 'Renew loan', loading: isBtnLoading, typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, onPress: async () => {
                    setBtnIsLoading(true);
                    !isBtnLoading &&
                        ctaAction &&
                        await triggerAction(ctaAction);
                    setBtnIsLoading(false);
                } }),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '100%'
                } },
                React.createElement(Typography, { label: 'Why renew your loan?', typeDLS: TypographyTypeDLS.B1M }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(View, { style: {
                        flex: 1,
                        height: 1,
                        backgroundColor: colorMapping[ColorTokens.Secondary_20]
                    } })),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            BenefitCard()));
    };
    const bottomCardRender = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                backgroundColor: colorMapping[ColorTokens.White]
            } },
            React.createElement(TouchableOpacity, { style: {
                    padding: 16,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderTopWidth: 1,
                    borderTopColor: colorMapping[ColorTokens.Grey_Chalk]
                }, onPress: () => {
                    onPressHowRenewalWorks();
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    } },
                    React.createElement(Icon, { name: IconTokens.LOAN_RENEWAL_1, size: IconSizeTokens.XXL }),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Typography, { label: 'See how renewal works', typeDLS: TypographyTypeDLS.B2M })),
                React.createElement(View, null,
                    React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_RIGHT_DLS, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Charcoal }))),
            React.createElement(TouchableOpacity, { style: {
                    padding: 16,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderTopWidth: 1,
                    borderTopColor: colorMapping[ColorTokens.Grey_Chalk],
                    borderBottomWidth: 1,
                    borderBottomColor: colorMapping[ColorTokens.Grey_Chalk]
                }, onPress: () => {
                    onPressFeeDetails();
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    } },
                    React.createElement(Icon, { name: IconTokens.LOAN_RENEWAL_1, size: IconSizeTokens.XXL }),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Typography, { label: 'Renewal fee and other details', typeDLS: TypographyTypeDLS.B2M })),
                React.createElement(View, null,
                    React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_RIGHT_DLS, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Charcoal }))),
            React.createElement(TouchableOpacity, { style: {
                    padding: 16,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottomWidth: 1,
                    borderBottomColor: colorMapping[ColorTokens.Grey_Chalk]
                }, onPress: () => {
                    onPressFaq();
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    } },
                    React.createElement(Icon, { name: IconTokens.SYSTEM_FAQ_V2_DLS, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Typography, { label: 'Frequently asked questions', typeDLS: TypographyTypeDLS.B2M })),
                React.createElement(View, null,
                    React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_RIGHT_DLS, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Charcoal })))));
    };
    const renewalFeeModalRender = () => {
        const renewalFee = _chargesData?.processingCharges;
        const interestRate = _chargesData?.interestRate;
        const tenure = _chargesData?.tenure;
        const interestAutoPay = _chargesData?.interestAutoPay;
        const principalRepayment = _chargesData?.principalRepaymentMode;
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0, marginBottom: -4 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: Platform.OS === "ios" ? 390 : isMobile(getScreenType(Dimensions.get('window').width)) ? 390 : 375, width: '100%', closeFunction: () => {
                    setRenewalFee(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true },
                React.createElement(View, { style: { paddingHorizontal: 16, paddingTop: 24, paddingBottom: 16 } },
                    React.createElement(Typography, { label: "Renewal fee and other details", typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night }),
                    React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                    React.createElement(View, { style: {
                            padding: 12,
                            borderRadius: 12,
                            borderWidth: 1,
                            borderColor: colorMapping[ColorTokens.Grey_Chalk],
                            backgroundColor: colorMapping[ColorTokens.White]
                        } },
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            } },
                            React.createElement(Typography, { label: 'Renewal fee (excl. of GST)', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Typography, { label: `₹${renewalFee ? addCommasToNumber(renewalFee) : renewalFee}`, typeDLS: TypographyTypeDLS.B1M })),
                        RenewalCardDivider(),
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            } },
                            React.createElement(Typography, { label: 'Interest rate', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Typography, { label: `${interestRate}%`, typeDLS: TypographyTypeDLS.B1M })),
                        RenewalCardDivider(),
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            } },
                            React.createElement(Typography, { label: 'Tenure', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Typography, { label: `${tenure} months`, typeDLS: TypographyTypeDLS.B1M })),
                        RenewalCardDivider(),
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            } },
                            React.createElement(Typography, { label: 'Interest autopay', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Typography, { label: `${interestAutoPay}${addSuffix(interestAutoPay)} of every month`, typeDLS: TypographyTypeDLS.B1M })),
                        RenewalCardDivider(),
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                            } },
                            React.createElement(Typography, { label: 'Principal repayment', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Typography, { label: `${principalRepayment}`, typeDLS: TypographyTypeDLS.B1M }))),
                    React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", fontSize: FontSizeTokens.SM, onPress: () => {
                                setRenewalFee(false);
                            } }))))));
    };
    const calHeight = () => {
        let height = 0;
        if (lenderId.toLowerCase() === LENDER_ID.TATA) {
            if (isMobileView()) {
                height = 300;
            }
            else
                height = 260;
        }
        else if (Platform.OS === "ios") {
            height = 375;
        }
        else if (isMobile(getScreenType(Dimensions.get('window').width))) {
            height = 366;
        }
        else
            height = 340;
        return height;
    };
    const renderHowItWorksCard = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0, marginBottom: -4 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: calHeight(), width: '100%', closeFunction: () => {
                    setHowItWorks(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true },
                React.createElement(View, { style: { paddingHorizontal: 16, paddingTop: 24, paddingBottom: 16 } },
                    React.createElement(Typography, { label: "How loan renewal works?", typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night }),
                    React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                alignContent: 'flex-start',
                                alignItems: 'flex-start',
                                alignSelf: 'flex-start',
                                justifyContent: 'flex-start'
                            } },
                            React.createElement(View, { style: { width: 40 } },
                                React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/eligible_credit_limit.png" }, style: { width: 40, height: 40 } }),
                                React.createElement(View, { style: {
                                        ...StyleSheet.absoluteFillObject,
                                        height: 28,
                                        alignContent: 'center',
                                        alignSelf: 'center',
                                        width: 1,
                                        marginTop: 42,
                                        marginLeft: 20,
                                        backgroundColor: '#E4E7EC',
                                    } })),
                            React.createElement(View, { style: { marginLeft: 12, flex: 1 } },
                                React.createElement(Typography, { label: lenderId.toLowerCase() === LENDER_ID.TATA ? 'Just confirm that you want to renew' : "Opt for loan renewal with the current or increased credit limit", typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Grey_Night, lineHeight: 20 }),
                                React.createElement(View, { style: { marginTop: 4 } },
                                    React.createElement(Typography, { label: lenderId.toLowerCase() === LENDER_ID.TATA ? 'Loan will be auto renewed on maturity date' : "Renew loan in just 2 mins", typeDLS: TypographyTypeDLS.B2R, lineHeight: 18, color: ColorTokens.Grey_Charcoal }))))),
                    lenderId.toLowerCase() !== LENDER_ID.TATA && React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(View, { style: { flexDirection: 'row', alignContent: 'center', alignItems: 'center' } },
                            React.createElement(View, { style: { width: 40 } },
                                React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/verify_interest_charges.png" }, style: { width: 40, height: 40 } }),
                                React.createElement(View, { style: {
                                        ...StyleSheet.absoluteFillObject,
                                        height: 28,
                                        alignContent: 'center',
                                        alignSelf: 'center',
                                        width: 1,
                                        marginTop: 42,
                                        marginLeft: 20,
                                        backgroundColor: '#E4E7EC',
                                    } })),
                            React.createElement(View, { style: { marginLeft: 12, flex: 1 } },
                                React.createElement(Typography, { label: "Complete your loan renewal application", typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Grey_Night, lineHeight: 20 }),
                                React.createElement(View, { style: { marginTop: 4 } },
                                    React.createElement(Typography, { label: "Confirm interest rate & charges, complete KYC, mandate, & sign agreement", typeDLS: TypographyTypeDLS.B2R, lineHeight: 18, color: ColorTokens.Grey_Charcoal }))))),
                    React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(View, { style: { flexDirection: 'row', alignContent: 'center', alignItems: 'center' } },
                            React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/withdraw_cash.png" }, style: { width: 40, height: 40 } }),
                            React.createElement(View, { style: { marginLeft: 12, flex: 1 } },
                                React.createElement(Typography, { label: "Start using your credit limit", typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Grey_Night, lineHeight: 20 }),
                                React.createElement(View, { style: { marginTop: 4 } },
                                    React.createElement(Typography, { label: "Withdraw cash flexibly ", typeDLS: TypographyTypeDLS.B2R, lineHeight: 18, color: ColorTokens.Grey_Charcoal }))))),
                    React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", fontSize: FontSizeTokens.SM, onPress: () => {
                                setHowItWorks(false);
                            } }))))));
    };
    const body = () => {
        return (React.createElement(View, { style: [
                styles.bodycontainer
            ] },
            WarningRender(),
            TopCardRender(),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            bottomCardRender(),
            React.createElement(Space, { size: SizeTypeTokens.XXXL })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(BoilerPlate, { height: height, headerChild: React.createElement(React.Fragment, null,
                React.createElement(CustomHeader, { title: 'Renew loan', needHelpAction: needHelpAction, goBackAction: goBackAction, triggerAction: triggerAction })), bottomChildren: null, backgroundColor: ColorTokens.Primary_05 },
            React.createElement(React.Fragment, null, body())),
        howItWorks && renderHowItWorksCard(),
        renewalFee && renewalFeeModalRender()));
};
const styles = StyleSheet.create({
    bodycontainer: {
        flex: 1,
        paddingTop: 16
    },
    creditLimitCardContainer: {
        padding: 16,
        borderRadius: 16,
        borderWidth: 1,
        backgroundColor: '#FFF',
        shadowColor: 'rgba(152, 162, 179, 0.20)',
        shadowOffset: {
            width: 0,
            height: 6,
        },
        shadowOpacity: 1,
        shadowRadius: 20,
        elevation: 3,
    },
    card1: {},
    card1ItemContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%'
    }
});
export default LoanRenewalLandingPage;
